import { Component, ViewContainerRef, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router, NavigationStart, NavigationEnd, NavigationError, NavigationCancel } from '@angular/router';
import { filter } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthService } from '@auth/auth.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html'
})
export class AppComponent implements OnInit, OnDestroy {

    subscription: Subscription;

    constructor(
        private spinner: NgxSpinnerService,
        private router: Router,
        public authService: AuthService
    ) {
        this.router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
                this.spinner.show(undefined, {
                    type: 'ball-spin-clockwise',
                    size: 'medium',
                    bdColor: 'rgba(0, 0, 0, 0.4)',
                    color: '#fff',
                    fullScreen: true
                });
            } else if (event instanceof NavigationEnd ||
                event instanceof NavigationError ||
                event instanceof NavigationCancel) {
                this.spinner.hide();
            }
        });
    }

    ngOnInit() {
        this.subscription = this.router.events
            .pipe(
                filter(event => event instanceof NavigationEnd)
            )
            .subscribe(() => window.scrollTo(0, 0));
    }


    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}
